// This file includes polyfills needed by Angular and is loaded before
// the app. You can add your own extra polyfills to this file.
import 'core-js';
import 'web-animations-js';
import 'zone.js/dist/zone';
import 'intersection-observer';

((window: any) => {
    if (!window) { return; }

    window['IEKeyboardEvent'] = function (type: string, options: KeyboardEventInit = {}) {
        const event = document.createEvent('KeyboardEvent') as any;

        // Firefox does not support `initKeyboardEvent`, but supports `initKeyEvent`.
        const initEventFn = (event.initKeyEvent || event.initKeyboardEvent).bind(event);
        const originalPreventDefault = event.preventDefault;

        initEventFn(type, options.bubbles, options.cancelable, window, 0, 0, 0, 0, 0, options.code);

        // Webkit Browsers don't set the keyCode when calling the init function.
        // See related bug https://bugs.webkit.org/show_bug.cgi?id=16735
        Object.defineProperties(event, {
            keyCode: { get: () => options.code },
            key: { get: () => options.key },
            altKey: { get: () => options.altKey },
            ctrlKey: { get: () => options.ctrlKey },
            shiftKey: { get: () => options.shiftKey },
            modifierCapsLock: { get: () => options.modifierCapsLock },
            modifierAltGraph: { get: () => options.modifierAltGraph },
            metaKey: { get: () => options.metaKey },
            location: { get: () => options.location },
            detail: { get: () => options.detail },
            repeat: { get: () => options.repeat },
        });

        // IE won't set `defaultPrevented` on synthetic events so we need to do it manually.
        event.preventDefault = function () {
            Object.defineProperty(event, 'defaultPrevented', { get: () => true });
            return originalPreventDefault.apply(this, arguments);
        };

        return event as KeyboardEvent;
    };

    // polyfill Safari media addEventListener :(
    if (window.matchMedia) {
        const mediaQueryList = matchMedia('all');
        if (mediaQueryList.addEventListener) { return; }

        const originalMatchMedia = matchMedia;

        window.matchMedia = function (mediaQuery: string): MediaQueryList {
            const mql = originalMatchMedia(mediaQuery);

            Object.defineProperty(
                mql,
                'addEventListener',
                {
                    enumerable: true,
                    value: function (_: string, listener: ((evt: any) => void)): void {
                        // tslint:disable-next-line: deprecation
                        return this.addListener.call(this, listener);
                    },
                },
            );
            Object.defineProperty(
                mql,
                'removeEventListener',
                {
                    enumerable: true,
                    value: function (_: string, listener: ((evt: any) => void)): void {
                        // tslint:disable-next-line: deprecation
                        return this.removeListener.call(this, listener);
                    },
                },
            );

            return mql;
        };
    }
})(window);

(window as any).global = window;
